import { Route } from "@angular/router";

export const CommunicationPaths = {
  NewsletterEdit: (newsletterId: number | string) => `nieuwsbrief/bewerken/${newsletterId}`,
  NewsletterAdd: "nieuwsbrief/toevoegen",
  NewsletterSend: (newsletterId: number | string) =>
    `nieuwsbrief/bewerken/${newsletterId}/ontvangers`,
  NewsletterOverview: "nieuwsbrief/overzicht",
  MailQueueList: "verzendlijsten",
  MailQueue: (mailQueueId: number | string) => `verzendlijst/${mailQueueId}`,
  MailTemplateList: "mailsjabloon/overzicht",
  MailTemplateAdd: "mailsjabloon/toevoegen",
  MailTemplateEdit: (mailTemplateId: number | string) => `mailsjabloon/${mailTemplateId}/bewerken`,
  EmailList: "e-mailadressen",
};

export default [
  {
    path: CommunicationPaths.NewsletterEdit(":id"),
    loadComponent: () =>
      import("./pages/newsletter-edit/newsletter-edit.component").then(
        (c) => c.NewsletterEditComponent
      ),
    data: {
      breadcrumb: "Nieuwsbrief bewerken",
      title: "Nieuwsbrief bewerken",
      subscriptionTypes: [1],
    },
  },
  {
    path: CommunicationPaths.NewsletterAdd,
    loadComponent: () =>
      import("./pages/newsletter-edit/newsletter-edit.component").then(
        (c) => c.NewsletterEditComponent
      ),
    data: {
      breadcrumb: "Nieuwsbrief toevoegen",
      title: "Nieuwsbrief toevoegen",
      subscriptionTypes: [1],
    },
  },
  {
    path: CommunicationPaths.NewsletterSend(":id"),
    loadComponent: () =>
      import("./pages/newsletter-send/newsletter-send.component").then(
        (c) => c.NewsletterSendComponent
      ),
    data: {
      breadcrumb: "Nieuwsbrief verzenden",
      title: "Nieuwsbrief verzenden",
      subscriptionTypes: [1],
    },
  },
  {
    path: CommunicationPaths.NewsletterOverview,
    loadComponent: () =>
      import("./pages/newsletter-list/newsletter-list.component").then(
        (c) => c.NewsletterListComponent
      ),
    data: {
      breadcrumb: "Nieuwsbrieven",
      title: "Nieuwsbrieven",
      subscriptionTypes: [1],
    },
  },
  {
    path: CommunicationPaths.MailQueueList,
    loadComponent: () =>
      import("./pages/mail-queue-list/mail-queue-list.component").then(
        (c) => c.MailQueueListComponent
      ),
    data: {
      breadcrumb: "Verzendlijsten",
      title: "Verzendlijsten",
    },
  },
  {
    path: CommunicationPaths.MailQueue(":id"),
    loadComponent: () => import("./pages/queue/queue.component").then((c) => c.QueueComponent),
    data: {
      breadcrumb: "Mailinglijst",
      title: "Mailinglijst",
    },
  },
  {
    path: CommunicationPaths.MailTemplateList,
    loadComponent: () =>
      import("./pages/mail-template-list/mail-template-list.component").then(
        (c) => c.MailTemplateListComponent
      ),
    data: {
      breadcrumb: "E-mailsjablonen",
      title: "E-mailsjablonen",
    },
  },
  {
    path: CommunicationPaths.MailTemplateAdd,
    loadComponent: () =>
      import("./pages/mail-template-edit/mail-template-edit.component").then(
        (c) => c.MailTemplateEditComponent
      ),
    data: {
      breadcrumb: "Toevoegen",
      title: "E-mailsjabloon toevoegen",
    },
  },
  {
    path: CommunicationPaths.MailTemplateEdit(":id"),
    loadComponent: () =>
      import("./pages/mail-template-edit/mail-template-edit.component").then(
        (c) => c.MailTemplateEditComponent
      ),
    data: {
      breadcrumb: "Bewerken",
      title: "E-mailsjabloon bewerken",
    },
  },
  {
    path: CommunicationPaths.EmailList,
    loadComponent: () =>
      import("./pages/email-list/email-list.component").then((c) => c.EmailListComponent),
    data: {
      breadcrumb: "E-mailadressen",
      title: "E-mailadressen",
    },
  },
] satisfies Route[];
